"use strict";

exports.__esModule = true;
var createOnFocus = function createOnFocus(name, focus) {
  return function () {
    return focus(name);
  };
};
exports.default = createOnFocus;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/events/createOnFocus.js
// module id = 255
// module chunks = 76301927324276 76662671623916 231608221292675